import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Routes } from "router/routes";
import { EventNavbar } from "layout/landing/eventNavbar";
import { EventFooter } from "layout/landing/eventFooter";
import { getEventBySlug } from "./data";
import { Hero } from "./hero";
import { Problem } from "./problem";
import { Learnings } from "./learnings";
import { Speaker } from "./speaker";
import { Cta } from "./cta";

const EventsUI = () => {
  const { slug = "" } = useParams<{ slug: string }>();
  const event = getEventBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 1000,
      offset: 100,
      easing: "ease-in-out",
      once: true,
    });
    AOS.refresh();
  }, []);

  if (!event) {
    return <Navigate to={Routes.home} replace />;
  }

  return (
    <div className="bg-white overflow-x-hidden">
      <EventNavbar lumaUrl={event.lumaUrl} />
      <Hero event={event} />
      <Problem event={event} />
      <Learnings event={event} />
      <Speaker event={event} />
      <Cta event={event} />
      <EventFooter />
    </div>
  );
};

export { EventsUI };
